import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
// get all user's reservation
export const getAllUserLDReservations = createAsyncThunk(
    "reservation/getAllUserLDReservations",
    async (_, { rejectWithValue }) => {
        try {
            const result = await axios.get(`get-user-LDReservations`, {
                withCredentials: true,
            });
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

// get reservation by id
export const getLDReservationById = createAsyncThunk(
    "reservation/getLDReservationById",
    async (reservationID: String | undefined, { rejectWithValue }) => {
        try {
            const result = await axios.get(`get-LDReservation/${reservationID}`, {
                withCredentials: true,
            });
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
// cancel reservation
export const cancelLDReservation = createAsyncThunk(
    "reservation/cancelLDReservation",
    async (reservationID: String | undefined, { rejectWithValue }) => {
        try {
            const result = await axios.put(`cancel-LDReservation/${reservationID}`, {
                withCredentials: true,
            });
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    }
);

// delete reservation
export const deleteLDReservation = createAsyncThunk(
    "reservation/deleteLDReservation",
    async (reservationID: String | undefined, { rejectWithValue }) => {
        try {
            const result = await axios.put(`delete-LDReservation/${reservationID}`, {
                withCredentials: true,
            });
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    }
);
//new file justificatif
export const uploadNewDocLDRes = createAsyncThunk(
    "reservation/uploadNewDocLDRes",
    async ({ documents, id, language }: any, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            //eslint-disable-next-line
            documents.map((document: any) => {
                formData.append("files", document);
            });

            formData.append("currentLanguage", language);

            const result = await axios.post(
                `/upload-new-document-ldReservation/${id}`,
                formData,
                {
                    withCredentials: true,
                }
            );
            if (!result.data.Success) {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    }
);
export const newLDReservation = createAsyncThunk(
    "new-LDResClient",
    async (
        {
            documents,
            createLDRInfo,
            userUpdateInfo,
            language,
            confirmSaveData,
        }: any,
        { rejectWithValue }
    ) => {
        try {
            const formData = new FormData();
            //eslint-disable-next-line
            documents.map((document: any) => {
                formData.append("files", document);
            });
            // console.log(createLDRInfo?.vehicleDriver?.[0]?.vehicleID);
            // console.log(createLDRInfo?.vehicleDriver?.[0]?.driverID)
            formData.append("vehicles", createLDRInfo?.vehicleDriver?.[0]?.vehicleID);
            formData.append("drivers", createLDRInfo?.vehicleDriver?.[0]?.driverID)
            // createLDRInfo?.vehicleDriver?.[0]?.vehicleID.map((vehicle:string) => {
            //   formData.append("vehicles", vehicle);
            // })
            // createLDRInfo?.vehicleDriver?.[0]?.driverID.map((driver: string) => {
            //   formData.append("drivers", driver);
            // })

            formData.append("LDResParkId", createLDRInfo?.LDResParkId);
            formData.append("startDate", createLDRInfo?.startTime);
            formData.append("endDate", createLDRInfo?.endTime);
            formData.append("vehicleType", createLDRInfo?.vehicleType);
            // formData.append("vehicles", createLDRInfo?.vehicleDriver?.[0]?.vehicleID);
            // formData.append("drivers", createLDRInfo?.vehicleDriver?.[0]?.driverID);
            //user data : 
            formData.append("country", userUpdateInfo?.country);
            formData.append("adress", userUpdateInfo?.adress);
            formData.append("userPhone", userUpdateInfo?.userPhone);
            formData.append("zipCode", userUpdateInfo?.zipCode);
            formData.append("state", userUpdateInfo?.state);
            if (userUpdateInfo?.tvaNumber) {
                formData.append("tvaNumber", userUpdateInfo?.tvaNumber);
            }
            formData.append("userName", userUpdateInfo?.userName);
            formData.append("userEmail", userUpdateInfo?.userEmail);
            formData.append("codeClient", userUpdateInfo?.codeClient);


            // ** confirmation data
            formData.append("saveAddress", confirmSaveData?.saveAddress);
            formData.append("savePhoneNumber", confirmSaveData?.savePhoneNumber);
            formData.append("saveTvaNumber", confirmSaveData?.saveTvaNumber);

            const result = await axios.post(`/new-LDResClient`, formData, {
                withCredentials: true,
            });
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

const ldReservationSlice = createSlice({
    name: "reservation longue durée",
    initialState: {
        ldReservation: {},
        ldReservations: [],
        loading: false,
        errors: null,
    },
    reducers: {
        clearErrors: (state) => {
            state.errors = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(newLDReservation.pending, (state) => {
                state.loading = true;
                state.errors = null;
            })
            .addCase(newLDReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.errors = null;
                state.ldReservation = action.payload.Reservation;
            })
            .addCase(newLDReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.errors = action.payload.Description;
            })
            // get all user's reservation
            .addCase(getAllUserLDReservations.pending, (state) => {
                state.loading = true;
                state.errors = null;
            })
            .addCase(getAllUserLDReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.errors = null;
                state.ldReservations = action.payload.Data;
            })
            .addCase(getAllUserLDReservations.rejected, (state: any, action: any) => {
                state.loading = false;
                state.errors = action.payload.Description;
            })
            // get reservation by id
            .addCase(getLDReservationById.pending, (state) => {
                state.loading = true;
                state.errors = null;
            })
            .addCase(getLDReservationById.fulfilled, (state, action) => {
                state.loading = false;
                state.errors = null;
                state.ldReservation = action.payload.Reservation;
            })
            .addCase(getLDReservationById.rejected, (state: any, action: any) => {
                state.loading = false;
                state.errors = action.payload.Description;
            })
            // cancel reservation
            .addCase(cancelLDReservation.pending, (state) => {
                state.loading = true;
                state.errors = null;
            })
            .addCase(cancelLDReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.errors = null;
                state.ldReservations = action.payload.Data;
            })
            .addCase(cancelLDReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.errors = action.payload.Description;
            })

            // delete reservation
            .addCase(deleteLDReservation.pending, (state) => {
                state.loading = true;
                state.errors = null;
            })
            .addCase(deleteLDReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.errors = null;
                state.ldReservations = action.payload.Data;
            })
            .addCase(deleteLDReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.errors = action.payload.Description;
            })
            //** new files
            .addCase(uploadNewDocLDRes.pending, (state) => {
                state.loading = true;
                state.errors = null;
            })
            .addCase(uploadNewDocLDRes.fulfilled, (state, action) => {
                state.loading = false;
                state.errors = null;
                state.ldReservations = action.payload.Data;
            })
            .addCase(uploadNewDocLDRes.rejected, (state: any, action: any) => {
                state.loading = false;
                state.errors = action.payload.Description;
            })

    },
});

export default ldReservationSlice.reducer;